// ── PUZZLE BANK — kila puzzle imehakikiwa kwa sheria za chess ─────────
// Awamu tatu: Ufunguzi (opening), Katikati (midgame), Mwisho (endgame).
// Kila solution ni move HALALI moja, imethibitishwa kwa programu.

export const PHASES = [
  { id: 'opening', name: 'Ufunguzi', icon: 'flag', desc: 'Mitego ya mwanzo wa mchezo' },
  { id: 'midgame', name: 'Katikati', icon: 'bolt', desc: 'Uma, pin, na dhabihu' },
  { id: 'endgame', name: 'Mwisho', icon: 'crown', desc: 'Mate na kuzaa askari' },
];

export const PUZZLES = [
  {
    id: 1, phase: 'opening', level: 'Rahisi', skill: 'Checkmate',
    fen: 'rnbqkbnr/pppp1ppp/8/4p3/6P1/5P2/PPPPP2P/RNBQKBNR b KQkq - 0 2',
    solution: { from: 'd8', to: 'h4' },
    hint: 'Weupe wamedhoofisha mfalme wao (f3+g4). Malkia mweusi amalize.',
    lessonSkill: 'Fool’s Mate — kudhoofisha mfalme mapema huadhibiwa haraka.',
  },
  {
    id: 2, phase: 'opening', level: 'Rahisi', skill: 'Kula Malkia',
    fen: 'rnbqkbnr/ppp2ppp/8/3pp3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - 0 3',
    solution: { from: 'f3', to: 'e5' },
    hint: 'Askari mweusi wa e5 hana mlinzi baada ya d5. Je farasi anaweza kula bure?',
    lessonSkill: 'Usiache askari bila mlinzi mwanzoni.',
  },
  {
    id: 3, phase: 'opening', level: 'Wastani', skill: 'Checkmate',
    fen: 'r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/5Q2/PPPP1PPP/RNB1K1NR w KQkq - 0 4',
    solution: { from: 'f3', to: 'f7' },
    hint: 'Scholar’s Mate: malkia na askofu wanalenga f7. Malkia achukue f7.',
    lessonSkill: 'Scholar’s Mate — linda f7/f2, ndio sehemu dhaifu mwanzoni.',
  },
  {
    id: 4, phase: 'opening', level: 'Wastani', skill: 'Checkmate',
    fen: 'r1bqkbnr/pppp1ppp/2n5/4p3/2B1P3/5Q2/PPPP1PPP/RNB1K1NR w KQkq - 0 3',
    solution: { from: 'f3', to: 'f7' },
    hint: 'Malkia na askofu wanalenga f7 — mahali dhaifu zaidi kwa mweusi.',
    lessonSkill: 'Scholar’s Mate — linda f7 mapema.',
  },
  {
    id: 5, phase: 'opening', level: 'Wastani', skill: 'Kula Malkia',
    fen: 'rnbqk1nr/pppp1ppp/8/2b1p3/2B1P3/8/PPPP1PPP/RNBQK1NR w KQkq - 0 3',
    solution: { from: 'd1', to: 'h5' },
    hint: 'Malkia h5 inatishia f7 na e5. Angalia kama kuna pigo lenye tishio mbili.',
    lessonSkill: 'Tishio mbili — malkia hushambulia sehemu mbili.',
  },
  {
    id: 6, phase: 'midgame', level: 'Rahisi', skill: 'Kula Rook',
    fen: '6k1/5ppp/8/3r4/8/8/8/3Q2K1 w - - 0 1',
    solution: { from: 'd1', to: 'd5' },
    hint: 'Rook ya adui haina mlinzi, iko mstari mmoja na malkia wako.',
    lessonSkill: 'Macho ya zawadi — ona kilichoachwa wazi.',
  },
  {
    id: 7, phase: 'midgame', level: 'Rahisi', skill: 'Kula Malkia',
    fen: '4k3/8/8/3q4/8/4N3/8/4K3 w - - 0 1',
    solution: { from: 'e3', to: 'd5' },
    hint: 'Malkia wa adui amesimama pale farasi wako anafika, hana mlinzi.',
    lessonSkill: 'Thamani — farasi kula malkia ni biashara bora.',
  },
  {
    id: 8, phase: 'midgame', level: 'Rahisi', skill: 'Checkmate',
    fen: '7k/5ppp/8/8/8/8/5PPP/1R5K w - - 0 1',
    solution: { from: 'b1', to: 'b8' },
    hint: 'Rook iende mstari wa 8. Mfalme mweusi hana pa kutoroka.',
    lessonSkill: 'Back-rank — askari watatu = gereza la mfalme.',
  },
  {
    id: 9, phase: 'midgame', level: 'Rahisi', skill: 'Checkmate',
    fen: '6k1/4nppp/8/8/8/8/5PPP/3R2K1 w - - 0 1',
    solution: { from: 'd1', to: 'd8' },
    hint: 'Farasi wa e7 haulinzi mstari wa 8. Rook imalize.',
    lessonSkill: 'Back-rank — hakikisha mstari wa mwisho unalindwa.',
  },
  {
    id: 10, phase: 'midgame', level: 'Wastani', skill: 'Checkmate',
    fen: '6k1/5ppp/8/8/8/8/5PPP/3R2K1 w - - 0 1',
    solution: { from: 'd1', to: 'd8' },
    hint: 'Mfalme amefungiwa na askari wake. Rook shika mstari wa mwisho.',
    lessonSkill: 'Back-rank mate — askari wasiohama huwa gereza.',
  },
  {
    id: 11, phase: 'midgame', level: 'Wastani', skill: 'Uma (Fork)',
    fen: '6k1/3q4/8/8/4N3/8/8/6K1 w - - 0 1',
    solution: { from: 'e4', to: 'f6' },
    hint: 'Farasi aguse mfalme na malkia kwa pigo moja.',
    lessonSkill: 'Uma (Fork) — pigo moja, malengo mawili.',
  },
  {
    id: 12, phase: 'midgame', level: 'Wastani', skill: 'Kula Rook',
    fen: 'r5k1/5ppp/8/8/8/8/5PPP/R5K1 w - - 0 1',
    solution: { from: 'a1', to: 'a8' },
    hint: 'Rook zenu ziko mstari mmoja. Chukua rook ya adui.',
    lessonSkill: 'Ubadilishaji — wakati mwingine kubadilishana ndiyo faida.',
  },
  {
    id: 13, phase: 'midgame', level: 'Wastani', skill: 'Kula Rook',
    fen: '3r2k1/5ppp/8/8/8/8/5PPP/3Q2K1 w - - 0 1',
    solution: { from: 'd1', to: 'd8' },
    hint: 'Malkia na rook ya adui mstari mmoja. Ichukue.',
    lessonSkill: 'Safu wazi — malkia hutawala mstari mzima.',
  },
  {
    id: 14, phase: 'midgame', level: 'Wastani', skill: 'Kula Malkia',
    fen: '2q3k1/5ppp/8/8/8/8/5PPP/2R3K1 w - - 0 1',
    solution: { from: 'c1', to: 'c8' },
    hint: 'Rook yako na malkia wa adui mstari mmoja; malkia hana mlinzi.',
    lessonSkill: 'Vipande vizito — shika safu wazi kwanza.',
  },
  {
    id: 15, phase: 'midgame', level: 'Wastani', skill: 'Checkmate',
    fen: '6k1/pp3ppp/8/8/8/8/PP3PPP/3R2K1 w - - 0 1',
    solution: { from: 'd1', to: 'd8' },
    hint: 'Mstari wa mwisho uko wazi. Rook imalize.',
    lessonSkill: 'Back-rank — tengeneza tundu la hewa kwa mfalme wako.',
  },
  {
    id: 16, phase: 'midgame', level: 'Ngumu', skill: 'Uma (Fork)',
    fen: '3q3k/8/8/6N1/8/8/8/6K1 w - - 0 1',
    solution: { from: 'g5', to: 'f7' },
    hint: 'Royal fork: farasi afike wapi aguse wote wawili?',
    lessonSkill: 'Royal fork — zawadi kubwa ya farasi.',
  },
  {
    id: 17, phase: 'midgame', level: 'Ngumu', skill: 'Kula Rook',
    fen: '2r3k1/5ppp/8/8/8/8/5PPP/2Q3K1 w - - 0 1',
    solution: { from: 'c1', to: 'c8' },
    hint: 'Malkia na rook ya adui mstari mmoja; rook haina mlinzi wa kutosha.',
    lessonSkill: 'Mstari wazi — vipande vizito hutawala safu wazi.',
  },
  {
    id: 18, phase: 'endgame', level: 'Rahisi', skill: 'Kula Malkia',
    fen: '8/P6k/8/8/8/8/8/6K1 w - - 0 1',
    solution: { from: 'a7', to: 'a8' },
    hint: 'Askari amefika mwisho — mzae kuwa malkia.',
    lessonSkill: 'Promotion — askari mmoja hubadili mchezo.',
  },
  {
    id: 19, phase: 'endgame', level: 'Rahisi', skill: 'Kula Malkia',
    fen: '8/8/8/8/8/8/4P3/4K1k1 w - - 0 1',
    solution: { from: 'e2', to: 'e4' },
    hint: 'Askari asonge mbele bila kizuizi — njia ya kuzaliwa iko wazi.',
    lessonSkill: 'Askari aliyepita — mlinde asonge hadi mwisho.',
  },
  {
    id: 20, phase: 'endgame', level: 'Rahisi', skill: 'Kula Malkia',
    fen: '8/8/8/8/8/2k5/2P5/2K5 w - - 0 1',
    solution: { from: 'c1', to: 'd1' },
    hint: 'Hii ni mchezo wa opposition. Tafuta hatua sahihi ya mfalme kusonga askari.',
    lessonSkill: 'Opposition — mfalme mbele ya askari hushinda.',
  },
  {
    id: 21, phase: 'endgame', level: 'Wastani', skill: 'Checkmate',
    fen: 'k7/2K5/8/8/8/8/8/1Q6 w - - 0 1',
    solution: { from: 'b1', to: 'b7' },
    hint: 'Malkia + mfalme dhidi ya mfalme. Mpe mate kona.',
    lessonSkill: 'Mate ya malkia — msukume mfalme kona.',
  },
  {
    id: 22, phase: 'endgame', level: 'Wastani', skill: 'Checkmate',
    fen: '7k/5ppp/8/8/8/8/8/R6K w - - 0 1',
    solution: { from: 'a1', to: 'a8' },
    hint: 'Mfalme amefungiwa na askari wake. Rook mstari wa mwisho.',
    lessonSkill: 'Back-rank — hata endgame, kona ni hatari.',
  },
];

export function getPuzzlesByPhase(phaseId) {
  if (!phaseId || phaseId === 'zote') return PUZZLES;
  return PUZZLES.filter(p => p.phase === phaseId);
}

export function getDailyPuzzles() {
  if (!PUZZLES.length) return [];
  const day = Math.floor(Date.now() / 86400000);
  const out = [];
  for (let i = 0; i < 3; i++) out.push(PUZZLES[(day * 3 + i) % PUZZLES.length]);
  return out;
}

export function getTodaysPuzzle() { return getDailyPuzzles()[0] || null; }
